var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertify-code"},[_c('img',{attrs:{"src":_vm.src,"alt":"点击刷新"},on:{"click":_vm.refreshCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }